import mixitup from 'mixitup';

export class Tags {
    mixer;
    lastFilter;

    init = (node) => {
        this.mixer = mixitup(node, {
            selectors: {
                target: '.js-tags-shuffle-item'
            },
            controls: {
                toggleDefault: 'all'
            },
            classNames: {
                block: '',
                elementFilter: '',
                elementToggle: '',
                modifierActive: 'active'
            }
        });

        this.mixer.toggleOn('all');

        $(this.select).on('change', (e) => {
            this.onChangeSelect(e.currentTarget.value);
        });
    }

    onChangeSelect = (value) => {
        console.log('value: ', value);
        // this.mixer.getState().activeFilter.selector = value;

        if (value == 'all'){
            this.mixer.filter('all');
        }else {
            this.mixer.filter(value);
        }

        console.log('activeFilter: ', this.mixer.getState().activeFilter.selector);
    }

    cancelFilter = (e) => {
        e.stopPropagation();
        const activeFilter = this.mixer.getState().activeFilter.selector;
        this.mixer.toggleOff(activeFilter);
        this.mixer.toggleOn('all');
    }

    constructor(node) {
        this.select = $(node).find('.c-select');
        this.init(node);

        $('.js-tags-shuffle-cancel').on('click', this.cancelFilter);
    }
}



// WEBPACK FOOTER //
// ./app/scripts/shared/Tags.js